/*
 * @Author: Src
 * @Date: 2025-06-26 15:24:57
 * @LastEditTime: 2025-07-01 10:06:14
 * @LastEditors: Src
 * @FilePath: /work-station/src/models/wark.model.ts
 * @Description: 头部注释配置模板
 */
import { Decimal } from 'decimal.js';

Decimal.set({ precision: 20 });
export class CPSInvestmentPromotionModel {
  static from(data: any) {
    const dataSource = data;
    const _data = data.map((item: any) => dataSourceForEach(item));
    Decimal.set({ precision: 20 });
    function dataSourceForEach(item: any) {
      const _item: any = item;
      let monthTarget: any = 0; let monthCompleted: any = 0; let monthCompletedRate: any = 0;
      dataSource.forEach((rem: any) => {
        if (item.dept_id === rem.dept_id) {
          const a = new Decimal(rem.target_quota);
          const _a = new Decimal(monthTarget);
          const b = new Decimal(rem.shop_num || 0);
          const _b = new Decimal(monthCompleted);
          monthTarget = _a.plus(a);
          monthCompleted = _b.plus(b);
          monthCompletedRate = `${((monthCompleted / monthTarget) * 100).toFixed(2)}%`;
        }
      });
      let groupTarget: any = 0;
      let groupCompleted: any = 0;
      let groupCompletedRate: any = 0;
      dataSource.forEach((rem: any) => {
        if (item.group_id === rem.group_id) {
          const a = new Decimal(rem.target_quota);
          const _a = new Decimal(groupTarget);
          const b = new Decimal(rem.shop_num || 0);
          const _b = new Decimal(groupCompleted);
          groupTarget = _a.plus(a);
          groupCompleted = _b.plus(b);
          groupCompletedRate = `${((groupCompleted / groupTarget) * 100).toFixed(2)}%`;
        }
      });
      _item.dept_target_quota = monthTarget.toFixed(0);
      _item.dept_activity_num = monthCompleted.toFixed(0);
      _item.dept_ratio = monthCompletedRate;
      _item.group_target_quota = groupTarget.toFixed(0);
      _item.group_activity_num = groupCompleted.toFixed(0);
      _item.group_ratio = groupCompletedRate;
      return _item;
    }
    return _data;
  }
}

export class WriteGMVAmountModel {
  static from(data: any) {
    const dataSource = data;
    const _data = data.map((item: any) => dataSourceForEach(item));
    Decimal.set({ precision: 20 });
    function dataSourceForEach(item: any) {
      const _item: any = item;
      let monthTarget: any = 0; let monthCompleted: any = 0; let monthCompletedRate: any = 0;
      dataSource.forEach((rem: any) => {
        if (item.dept_id === rem.dept_id) {
          const a = new Decimal(rem.gmv_target);
          const _a = new Decimal(monthTarget);
          const b = new Decimal(rem.gmv || 0);
          const _b = new Decimal(monthCompleted);
          monthTarget = _a.plus(a);
          monthCompleted = _b.plus(b);
          monthCompletedRate = `${((monthCompleted / monthTarget) * 100).toFixed(2)}%`;
        }
      });
      let groupTarget: any = 0;
      let groupCompleted: any = 0;
      let groupCompletedRate: any = 0;
      dataSource.forEach((rem: any) => {
        if (item.group_id === rem.group_id) {
          const a = new Decimal(rem.gmv_target);
          const _a = new Decimal(groupTarget);
          const b = new Decimal(rem.gmv || 0);
          const _b = new Decimal(groupCompleted);
          groupTarget = _a.plus(a);
          groupCompleted = _b.plus(b);
          groupCompletedRate = `${((groupCompleted / groupTarget) * 100).toFixed(2)}%`;
        }
      });
      _item.dept_gmv_target = monthTarget.toFixed(2);
      _item.dept_gmv = monthCompleted.toFixed(2);
      _item.dept_gmv_ratio = monthCompletedRate;
      _item.group_gmv_target = groupTarget.toFixed(2);
      _item.group_gmv = groupCompleted.toFixed(2);
      _item.group_gmv_ratio = groupCompletedRate;
      return _item;
    }
    return _data;
  }
}


export class ParticipateInActivitiesModel {
  static from(data: any) {
    const dataSource = data;
    const _data = data.map((item: any) => dataSourceForEach(item));
    Decimal.set({ precision: 20 });
    function dataSourceForEach(item: any) {
      const _item: any = item;
      let monthTarget: any = 0; let monthCompleted: any = 0; let monthCompletedRate: any = 0;
      dataSource.forEach((rem: any) => {
        if (item.dept_id === rem.dept_id) {
          const a = new Decimal(rem.activity_target_num || 0);
          const _a = new Decimal(monthTarget);
          const b = new Decimal(rem.activity_num || 0);
          const _b = new Decimal(monthCompleted);
          monthTarget = _a.plus(a);
          monthCompleted = _b.plus(b);
          monthCompletedRate = `${((monthCompleted / monthTarget) * 100).toFixed(2)}%`;
        }
      });
      let groupTarget: any = 0;
      let groupCompleted: any = 0;
      let groupCompletedRate: any = 0;
      dataSource.forEach((rem: any) => {
        if (item.group_id === rem.group_id) {
          const a = new Decimal(rem.activity_target_num || 0);
          const _a = new Decimal(groupTarget);
          const b = new Decimal(rem.activity_num || 0);
          const _b = new Decimal(groupCompleted);
          groupTarget = _a.plus(a);
          groupCompleted = _b.plus(b);
          groupCompletedRate = `${((groupCompleted / groupTarget) * 100).toFixed(2)}%`;
        }
      });
      _item.dept_activity_target_num = monthTarget.toFixed(0);
      _item.dept_activity_num = monthCompleted.toFixed(0);
      _item.group_activity_target_num = groupTarget.toFixed(0);
      _item.group_activity_num = groupCompleted.toFixed(0);
      _item.dept_activity_ratio = monthCompletedRate;
      _item.group_activity_ratio = groupCompletedRate;
      return _item;
    }
    return _data;
  }
}
